var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"placeholder":_vm.label},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }